export default "__VITE_ASSET__MGqShMaN__"